'use strict';

const isEmpty = require('lodash.isempty');

const tracking = require('dibs-tracking');
const trackingHelpers = require('../../tradeProfiles/trackingHelpers');

const GalleryStore = require('../stores/GalleryStore');
const GAC = require('../helpers/GalleryConstants.es');

// DATA LAYER settings for gallery
const DATA_LAYER_SETTINGS = Object.freeze({
    pageType: 'Other',
    pageLevel: 'Other',
    pageSubType: 'Trade Firm',

    countOfItems: 0,
    ecommerce: undefined,
});

// List for e commerce events
const LIST_SIMILAR_ITEMS = 'related items on trade firm photo';

// Category for gallery events
const CATEGORY_TRADE_GALLERY = 'trade firm project image interaction';

// targets for trackLinkClick()
const GA_LINK_TARGETS = {
    CLOSE: 'close',
    MORE: 'more projects',
    PROJECT: 'trade firm project link',
    VIEW_SIMILAR: 'similar products see all',
    TOOLTIP_LINK: 'photo tag tooltip view similar pieces',
};

// helper for keeping track of which images have been zoomed
// since we do not track zooming the same image twice
const _isNotTracked = (() => {
    const tracked = [];
    return photoId => {
        // has been tracked already
        if (tracked.indexOf(photoId) > -1) {
            return false;
        }

        // has not been tracked
        tracked.push(photoId);
        return true;
    };
})();

// Returns labels of the form [Index of Photo]/[Number of Photos]
function _getEventLabel(galleryStore) {
    const index = galleryStore.getCurrentPhotoIndex() + 1;
    const total = galleryStore.getTotalNumberOfPhotos();
    return `${index}/${total}`;
}

function trackPhotoSwitch(ac, { action, pageType }, done) {
    let trackObj;

    if (pageType === GAC.pageTypes.PDP) {
        trackObj = {
            action: 'related rooms carousel',
            category: 'promo interaction',
            label: `${action} arrow clicked`,
        };
    } else {
        trackObj = {
            action: `image ${action} image displayed`,
            category: CATEGORY_TRADE_GALLERY,
            label: _getEventLabel(ac.getStore(GalleryStore)),
        };
    }

    tracking.trackEvent(trackObj);
    done();
}

function trackMobileZoom(ac, payload, done) {
    const galleryStore = ac.getStore(GalleryStore);
    const photoId = galleryStore.getCurrentPhoto('id');

    if (_isNotTracked(photoId)) {
        tracking.trackEvent({
            action: 'mobile image zoom',
            category: CATEGORY_TRADE_GALLERY,
            label: _getEventLabel(ac.getStore(GalleryStore)),
        });
    }

    done();
}

function trackLinkClick(ac, { target, label }, done) {
    tracking.trackEvent({
        category: CATEGORY_TRADE_GALLERY,
        action: `${target} clicked`,
        label,
    });
    done();
}

function trackTooltipDisplayed(ac, payload, done) {
    tracking.trackEvent({
        category: CATEGORY_TRADE_GALLERY,
        action: 'photo tag tooltip displayed',
    });
    done();
}

function trackSimilarItemImpressions(ac, payload, done) {
    const { products = {} } = ac.getStore(GalleryStore).getSimilarItemsTracking();
    if (!isEmpty(products)) {
        tracking.trackEcommerce({
            type: 'productImpression',
            products: Object.keys(products).map(id =>
                Object.assign({}, products[id], {
                    list: LIST_SIMILAR_ITEMS,
                })
            ),
        });
    }
    done();
}

function trackSimilarItemClick(ac, { itemId }, done) {
    if (typeof itemId === 'string') {
        const { products = {} } = ac.getStore(GalleryStore).getSimilarItemsTracking();
        const product = products[itemId];

        if (typeof product !== 'undefined') {
            tracking.trackEcommerce({
                type: 'productClick',
                products: [product],
                actionField: {
                    list: LIST_SIMILAR_ITEMS,
                },
            });
        }
    }
    done();
}

function updateCountOfItems(ac, payload, done) {
    const { countOfItems = 0 } = ac.getStore(GalleryStore).getSimilarItemsTracking();
    tracking.addGTMMessage({ countOfItems });
    done();
}

function fireVPV(ac, payload, done) {
    const galleryStore = ac.getStore(GalleryStore);
    const { countOfItems = 0 } = galleryStore.getSimilarItemsTracking();
    const firm = galleryStore.getPhotoFirm('urlLabel');
    const project = galleryStore
        .getPhotoProject('name', '')
        .replace(/\s+/g, '-') // replace spaces with '-' for vpv
        .toLowerCase(); // lower case for vpv

    // update dataLayer object (before page view!)
    tracking.addGTMMessage(DATA_LAYER_SETTINGS);

    // fire pageview
    trackingHelpers.trackTradeProfilesVpv({
        page: 'gallery',
        firm,
        project,
        customDimensions: { countOfItems },
    });

    done();
}

// (Note: ordering of these tracking events is important
//      for making sure events are associated with correct pages)
function fireVPVAndImpressions(ac, payload, done) {
    ac.executeAction(fireVPV);
    ac.executeAction(trackSimilarItemImpressions);
    done();
}

module.exports = {
    fireVPV,
    fireVPVAndImpressions,
    trackSimilarItemImpressions,
    trackSimilarItemClick,
    updateCountOfItems,
    trackPhotoSwitch,
    trackMobileZoom,
    trackLinkClick,
    trackTooltipDisplayed,
    GA_LINK_TARGETS,
};



// WEBPACK FOOTER //
// ./assets/js/gallery/actions/galleryTrackingActions.es.js